import React from 'react';
import Link from 'next/link';

interface DropdownLinkProps {
  href: string;
  children: React.ReactNode;
  icon?: React.ReactNode; // Optional icon
}

const DropdownLink: React.FC<DropdownLinkProps> = ({ href, children, icon }) => {
  return (
    <Link
      href={href}
      className="group flex justify-end items-center gap-2.5 self-stretch p-3 rounded-md hover:bg-blue-50 hover:text-blue-500 transition-colors duration-200"
    >
      {children}
      {icon && <span className="mr-2">{icon}</span>}
    </Link>
  );
};

export default DropdownLink;
